/**
 * PATH: apps/assets/src/pages/MaintenancePage.tsx
 * PURPOSE: Asset maintenance management
 */
import { EmptyRegister } from './emptyRegister'

export default function MaintenancePage() {
  return (
    <EmptyRegister
      title="Maintenance"
      detail="No maintenance records are connected."
    />
  )
}
